module.exports = __webpack_public_path__ + "static/media/pic4.c553763e.jpg";